import React from 'react';

type Props = {
  label: string;
  required?: boolean;
  hint?: string;
  error?: string;
  children: React.ReactNode;
  className?: string;
};

export function FormField({ label, required, hint, error, children, className = '' }: Props) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-content-tertiary mb-1.5">
        {label} {required ? <span className="text-content-danger ml-0.5">*</span> : null}
      </label>
      {children}
      {error ? <div className="text-content-danger text-xs mt-1.5">{error}</div> : null}
      {hint && !error ? <div className="text-icon-subtle text-xs mt-1.5">{hint}</div> : null}
    </div>
  );
}

